export const INITIALIZE = '@@root/INITIALIZE';

export const initialize = () => ({
  type: INITIALIZE,
});
